export default "/images/vendor/flag-icon-css/flags/4x3/me.svg?0c03b01f0a036dd1e720645682dbe50c";